/**
 * Constantes de recursos (TKT-022).
 * ADR-0011: Ímpetu del Deudor Carmesí. HP genérico.
 */

export const HP_DEFAULT_MAX = 100;

/** Ímpetu (ADR-0011): 0..100 con decay 1/s tras 3s sin atacar. */
export const MOMENTUM_MAX = 100;
export const MOMENTUM_INITIAL = 0;
export const MOMENTUM_DECAY_PER_SEC = 1;
export const MOMENTUM_DECAY_DELAY_MS = 3000;
